/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/function-component-definition */
import React from 'react';
import {
  FaParking,
  FaUtensils,
  FaDog,
  FaConciergeBell,
  FaSwimmingPool,
  FaWifi,
  FaWheelchair,
  FaTv,
  FaSmoking,
  FaBus,
  FaFireExtinguisher,
} from 'react-icons/fa';
import {
  MdFitnessCenter,
  MdFamilyRestroom,
  MdSpa,
  MdOutlineIron,
  MdOutlineNordicWalking,
  MdMeetingRoom,
  MdOutlineCleaningServices,
  MdGolfCourse,
} from 'react-icons/md';
import {
  TbAirConditioning,
  TbFirstAidKit,
  TbWheelchairOff,
} from 'react-icons/tb';
import { GiLift, GiWineBottle } from 'react-icons/gi';
import { FaBanSmoking, FaCarTunnel } from 'react-icons/fa6';
import { Ri24HoursFill } from 'react-icons/ri';
import { BiSolidDrink } from 'react-icons/bi';
import PropTypes from 'prop-types';
import AppTooltip from '../../../shared/components/app-tool-tip/AppTooltip';

const facilityIcons = {
  PARKING: <FaParking />,
  RESTAURANT: <FaUtensils />,
  'PETS ALLOWED': <FaDog />,
  'ROOM SERVICE': <FaConciergeBell />,
  '24-HOUR FRONT DESK': <Ri24HoursFill />,
  'FITNESS CENTRE': <MdFitnessCenter />,
  'NON-SMOKING': <FaBanSmoking />,
  'NON-SMOKING ROOMS': <FaBanSmoking />,
  'FAMILY ROOMS': <MdFamilyRestroom />,
  'MEETING ROOM': <MdMeetingRoom />,
  'FIRE EXTINGUISHER': <FaFireExtinguisher />,
  'FIRST AID KIT': <TbFirstAidKit />,
  'DAILY HOUSEKEEPING': <MdOutlineCleaningServices />,
  'GOLF COURSE': <MdGolfCourse />,
  'LIFT ACCESS': <GiLift />,
  SPA: <MdSpa />,
  'FREE WIFI': <FaWifi />,
  'SWIMMING POOL': <FaSwimmingPool />,
  'AIR CONDITIONING': <TbAirConditioning />,
  BAR: <GiWineBottle />,
  'LAUNDRY SERVICE': <MdOutlineIron />,
  'CAR PARK': <FaCarTunnel />,
  'WHEELCHAIR ACCESSIBLE': <FaWheelchair />,
  'WHEELCHAIR ACCESSIBLE NO': <TbWheelchairOff />,
  NIGHTCLUB: <BiSolidDrink />,
  TELEVISION: <FaTv />,
  'SMOKING AREA': <FaSmoking />,
  'TRANSFER SERVICE': <FaBus />,
  'FACILITIES FOR DISABLED GUESTS': <MdOutlineNordicWalking />,
};

const FacilityIcons = ({ hotelData, showTitle }) => {
  const availableFacilities = hotelData.fcList.filter((facility) =>
    Object.keys(facilityIcons).includes(facility.toUpperCase()),
  );
  const hasMore = hotelData.fcList.filter(
    (facility) =>
      Object.keys(facilityIcons).includes(facility.toUpperCase()) === false,
  );

  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
      {availableFacilities.map((facility) => (
        <div key={facility} style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', color: '#555' }} title={facility}>
            {facilityIcons[facility.toUpperCase()]}
          </div>
          {showTitle && <span style={{ fontSize: '12px' }}>{facility}</span>}
        </div>
      ))}
      {hasMore.length > 0 && (
        <AppTooltip
          title="+More"
          content={hasMore.join(', ')}
          tooltipClassName="d-flex align-items-end fs-14 fw-500"
        />
      )}
    </div>
  );
};

FacilityIcons.propTypes = {
  hotelData: PropTypes.object,
  showTitle: PropTypes.bool,
};

export default FacilityIcons;
